import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy URL — supplier definitions now live at /suppliers/definitions.
export const Route = createFileRoute('/console/$orgId/configuration/vendor-management/suppliers/search/definitions')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/console/$orgId/configuration/vendor-management/suppliers/definitions',
            params,
            replace: true,
        });
    },
});
